var Languages = /*#__PURE__*/function (Languages) {
  Languages["English"] = "en";
  Languages["French"] = "fr";
  Languages["German"] = "de";
  Languages["Italian"] = "it";
  Languages["Japanese"] = "ja";
  Languages["Portuguese"] = "pt";
  Languages["Spanish"] = "es";
  return Languages;
}({});
var DefaultLanguage = Languages.English;

export { DefaultLanguage, Languages };
